import { render, staticRenderFns } from "./FormEmailEdit.vue?vue&type=template&id=6ed9d958&scoped=true&"
import script from "./FormEmailEdit.vue?vue&type=script&lang=ts&"
export * from "./FormEmailEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed9d958",
  null
  
)

export default component.exports